import Api from '@common/services/api';

export const fetchEvaluation = async (organisationId: string, evaluationId: string) => {
  const data = await Api.get(
    `/v1/organisations/${organisationId}/performance/evaluations/${evaluationId}`
  );

  return data;
};
